import React from 'react';
import { 
  ArrowLeft, 
  Archive, 
  AlertOctagon, 
  Trash2, 
  Mail, 
  Clock, 
  CheckCircle,
  Tag,
  MoreVertical,
  ChevronDown,
  Printer,
  ExternalLink,
  Reply,
  ReplyAll,
  Forward,
  Star
} from 'lucide-react';
import { format } from 'date-fns';

const GmailMail = ({ mail, onBack, onDelete, onToggleStar }) => {
  const formatFullDate = (dateStr) => {
    const date = new Date(dateStr);
    return format(date, "EEEE, MMMM d, yyyy 'at' h:mm a");
  };

  return (
    <div className="gmail-mail" data-testid="gmail-mail-view">
      {/* Toolbar */}
      <div className="gmail-mail-tools">
        <div className="gmail-mail-tools-left">
          <button className="gmail-icon-btn" onClick={onBack} data-testid="gmail-back-btn">
            <ArrowLeft size={20} />
          </button>
          <button className="gmail-icon-btn">
            <Archive size={20} />
          </button>
          <button className="gmail-icon-btn">
            <AlertOctagon size={20} />
          </button>
          <button className="gmail-icon-btn" onClick={onDelete} data-testid="gmail-delete-btn">
            <Trash2 size={20} />
          </button>
          <div className="gmail-tools-divider" />
          <button className="gmail-icon-btn">
            <Mail size={20} />
          </button>
          <button className="gmail-icon-btn">
            <Clock size={20} />
          </button>
          <button className="gmail-icon-btn">
            <CheckCircle size={20} />
          </button>
          <button className="gmail-icon-btn">
            <Tag size={20} />
          </button>
          <button className="gmail-icon-btn">
            <MoreVertical size={20} />
          </button>
        </div>
        <div className="gmail-mail-tools-right">
          <button className="gmail-icon-btn">
            <ChevronDown size={20} />
          </button>
          <button className="gmail-icon-btn">
            <Printer size={20} />
          </button>
          <button className="gmail-icon-btn">
            <ExternalLink size={20} />
          </button>
        </div>
      </div>

      {/* Mail Content */}
      <div className="gmail-mail-body">
        <div className="gmail-mail-header">
          <div className="gmail-mail-subject-row">
            <h2 className="gmail-mail-subject">{mail.subject}</h2>
            <button className="gmail-icon-btn" onClick={onToggleStar}>
              <Star 
                size={20} 
                className={mail.isStarred ? 'gmail-star--active' : ''} 
                fill={mail.isStarred ? '#f4b400' : 'none'}
              />
            </button>
          </div>
          
          <div className="gmail-mail-meta">
            <div className="gmail-mail-sender-avatar">
              {(mail.fromName || mail.from).charAt(0).toUpperCase()}
            </div>
            <div className="gmail-mail-sender-info">
              <div className="gmail-mail-sender-name">
                <strong>{mail.fromName || mail.from}</strong>
                <span className="gmail-mail-sender-email">&lt;{mail.from}&gt;</span>
              </div>
              <div className="gmail-mail-recipient">
                to {mail.to === 'me@company.com' ? 'me' : mail.to}
              </div>
            </div>
            <div className="gmail-mail-date">
              {formatFullDate(mail.date)}
            </div>
          </div>
        </div>

        <div className="gmail-mail-content">
          <p>{mail.body}</p>
        </div>

        {/* Reply Actions */}
        <div className="gmail-mail-actions">
          <button className="gmail-reply-btn">
            <Reply size={18} />
            <span>Reply</span>
          </button>
          <button className="gmail-reply-btn">
            <Forward size={18} />
            <span>Forward</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GmailMail;
